<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：电表充值订单详情
    -->
	<div>
		<!-- start -->
		<div class="bg_add">
			<div class="changead" v-show="firstStep">
				<div class="changeadinput_create" >
					<el-input v-model="$route.params.metercode" style="float: left;width:120px;margin-right: 5px;" :disabled="true"></el-input>
					<el-input v-if="typeKey != 7" v-model="total" placeholder="请输入金额(元)" :maxlength="5" :autofocus="true" style="float: left;width:120px;margin-right: 5px;"></el-input>
					<el-input v-if="typeKey == 7" v-model="total_dun" placeholder="请输入吨数(吨)" :maxlength="5" :autofocus="true" style="float: left;width:120px;margin-right: 5px;"></el-input>
					<template>
						<el-select v-model="paytype" placeholder="请选择支付方式" style="width:145px;float: left;">
							<el-option
								v-for = "(item,index) in items"
								:key="index"
								:label="item.name"
								:value="item.id">
								{{item.name}}
							</el-option>
						</el-select>
					</template>
					<p class="showRt" v-if="paytype == 7">声明：直充仅保证表正常运行，为系统提供数据支持，与实际缴费购买金额无关，并无其他实际意义。</p>
					<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="onNext">下一步</el-button>
						<el-button @click="$router.go(-1)">取 消</el-button>
					</span>
				</div>
			</div>

			<!-- infos -->
			<div class="infos" v-show="ladderShow">

				<div class="infos_row">
					<label>当前阶梯：</label>
					<span><span class="b">{{ladderinfo.level}}</span>阶梯</span>
					<a href="/explain/explain-rule" class="right" target="_blank">规则</a>
				</div>

				<div class="infos_row">
					<label>当前本年电表用量：</label>
					<span><span class="b">{{ladderinfo.yeartotal}}</span>度</span>
				</div>

				<div class="infos_row">
					<label>超出阶梯用量：</label>
					<span><span class="b">{{ladderinfo.exceed}}</span>度</span>
				</div>

				<br />

				<div class="infos_row">
					<label>充值金额：</label>
					<span><span class="b">{{yuan(ladderinfo.money)}}</span>元</span>
				</div>

				<div class="infos_row">
					<label>应补交阶梯差价：</label>
					<span><span class="b">{{yuan(ladderinfo.diff)}}</span>元</span>
					<a :href="'/explain/explain-detailed?yeartotal=' + ladderinfo.yeartotal + '&newyear=' + ladderinfo.newYear" target="_blank">
						<i class="el-icon-warning"></i>
					</a>
				</div>

				<div class="infos_row">
					<label>存入零钱：</label>
					<span><span class="b">{{ladderinfo.pocket_money}}</span>元 （零钱累计满1元系统自动充值到电表）</span>
					<a href="/explain/explain-why" target="_blank">
						<i class="el-icon-warning"></i>
					</a>
				</div>

				<div class="infos_row infos_red">
					<label>剩余金额：</label>
					<span><span class="b">{{yuan(ladderinfo.amount)}}</span>元</span>
				</div>

				<div class="infos_row">
					<p>您当前电量已超出标准范围，如继续购电则会自动扣除差价，如若同意则点击“确认”按钮继续操作。</p>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="onLadder">确认</el-button>
					<el-button @click="firstStep = true, ladderShow = false">取 消</el-button>
				</span>

			</div>

			<!-- ent -->
			<div class="create" v-show="next">
				<!--弹窗-->
				<span><h4>订单名称：</h4>{{orderinfo.order_title}}</span>
				<span><h4>订单编号：</h4>{{orderinfo.ordercode}}</span>
				<span><h4>表号：</h4>{{orderinfo.metercode}}</span>
				<span><h4>业主姓名：</h4>{{orderinfo.owner_name}}</span>
				<span><h4>业主电话：</h4>{{orderinfo.owner_phone}}</span>
				<span><h4>地址：</h4>{{orderinfo.address}}</span>
				<span>
					<h4>支付方式：</h4>
					<rt v-if="1 == orderinfo.pay_type">支付宝</rt>
					<rt v-if="2 == orderinfo.pay_type">微信</rt>
					<rt v-if="3 == orderinfo.pay_type">银联</rt>
					<rt v-if="4 == orderinfo.pay_type">现金</rt>
					<rt v-if="5 == orderinfo.pay_type">支票</rt>
					<rt v-if="6 == orderinfo.pay_type">光大银行</rt>
					<rt v-if="7 == orderinfo.pay_type">直充</rt>
				</span>
				<span v-if="typeKey != 7"><h4>支付前费用余额：</h4>{{orderinfo.balance_before/100}} (元)</span>
				<span v-if="nextType == 1"><h4>支付前本年用量：</h4>{{orderinfo.yeartotal / 100}}度</span>
				<span v-if="nextType == 1"><h4>剩余金额：</h4><span class="text_blue text_bold">￥{{orderinfo.meter_monry / 100}}</span></span>
				<span v-if="typeKey != 7"><h4>支付金额：</h4>{{orderinfo.total/100}} (元)</span>
				<span v-if="nextType == 1"><h4>补交阶梯差价：</h4><span class="text_red">￥{{orderinfo.diff_money / 100}}</span></span>
				<span v-if="nextType == 1"><h4>存入零钱：</h4>￥{{orderinfo.pocket_in / 100}}</span>
				<span v-if="typeKey != 7"><h4>透支金额/吨数:</h4><span class="text_red">{{orderinfo.overdraft/100}} (元)</span></span>
				<span v-if="nextType == 1"><h4>本次充值后零钱余额：</h4>￥{{orderinfo.pocket_after / 100}}</span>
				<span v-if="nextType == 1"><h4>本次充值后零钱支付：</h4>￥{{orderinfo.pocket_out / 100}}</span>
				<span v-if="typeKey != 7"><h4>支付后费用余额：</h4>{{orderinfo.balance_after/100}} (元)</span>

				<span v-if="typeKey == 7"><h4>支付前剩余吨数:</h4>{{orderinfo.balance_before / 100}} (吨)</span>
				<span v-if="typeKey == 7"><h4>透支金额/吨数:</h4>{{orderinfo.overdraft / 100}} (元)</span>
				<span v-if="typeKey == 7"><h4>支付金额：</h4>{{orderinfo.total / 100}} (元)</span>
				<span v-if="typeKey == 7"><h4>支付后剩余吨数：</h4>{{orderinfo.balance_after / 100}} (吨)</span>

				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="successOrder">下一步</el-button>
					<el-button @click="cancel">取 消</el-button>
				</span>
	
				<!--alertend-->
			</div>

			<!-- code -->
			<div class="er_img" v-if="erImg">
				<h2 v-if="orderinfo.pay_type == 2">请使用微信扫描下方二维码</h2>
				<h2 v-if="orderinfo.pay_type == 3">请使用浏览器扫描下方二维码</h2>
				<div id="qrcodes"></div>
				<p>{{payMessage}}</p>
				<!--
                	作者：814518491@qq.com
                	时间：2017-11-13
                	描述：535897
                
				-->
				<!--<el-button type="success"
						@click="print"
						v-if="printItem"
				>
					打印订单
				</el-button>-->
				<el-button type="primary" @click="closeErImg">关闭</el-button>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.showRt{
		color:red;
		font-size: 12px;
		text-align: left;
	}
	.bg_add{
		background-color: rgba(0,0,0,.7);
		width: 100%;
		height: 965px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 6;
	}
	.changead{
		background-color: white;
		width:450px;
		position: absolute;
		left: 740px;
		top: 340px;
		color: white;
		z-index: 3;
		overflow: hidden;
		padding: 15px;
		border-radius: 15px;
		border:1px solid #ccc;
		box-shadow: 2px 2px 2px #000;
	}
	.changeadinput_create{
		width: 400px;
		margin: 0 auto;
		text-align: center;
		padding: 20px 0;
		overflow: hidden;
	}
	.create{
		border:1px solid red;
		width: 600px;
		margin:0 auto;
		background-color: white;
		border-radius: 15px;
		border:1px solid #ccc;
		box-shadow: 2px 2px 2px #000;
		padding: 10px;
		margin-top: 220px;
		overflow: hidden;
		padding-bottom: 20px;
	}
	.create span{
		display: inline-block;
		width: 600px;
		height: 30px;
		line-height: 30px;
		border-bottom:1px solid #ccc;
	}
	.create span:last-child{
		border:none
	}
	.create span h4{
		display: inline-block;
		width: 166px;
		margin: 0;
		padding: 0;
		font-weight: 100;
	}
	.dialog-footer {
		display: block;
		width: 100%;
		text-align: center;
		margin-top: 20px;
		float: left;
		span{
			margin:2px 0 !important;
		}
	}
	.er_img{
		position: absolute;
		background-color: rgba(0,0,0,.5);
		width: 623px;
		height: 423px;
		top: 220px;
		left: 648px;
		margin: 0 auto;
		text-align: center;
		color:white;
		font-size: 20px;
		font-family: "微软雅黑";
		font-weight: bold;
		letter-spacing: 5px;
	}
	.er_img #qrcodes{
		margin: auto;
		margin-top: 25px;
		display: inline-block;
		width: auto;
	}
	@media only screen and (max-width:1400px ) {
		.changead{
			background-color: white;
			width:450px;
			position: absolute;
			left: 440px;
			top: 240px;
			color: white;
			z-index: 3;
			overflow: hidden;
			padding: 15px;
			border-radius: 15px;
			border:1px solid #ccc;
			box-shadow: 2px 2px 2px #000;
		}
		.er_img{
		position: absolute;
		background-color: rgba(0,0,0,.5);
		width: 623px;
		height: 423px;
		top: 220px;
		left: 320px;
		margin: 0 auto;
		text-align: center;
		color:white;
		font-size: 20px;
		font-family: "微软雅黑";
		font-weight: bold;
		letter-spacing: 5px;
		}
		.er_img img{
			margin-top: 90px;
			margin-left: 200px;
			display: block;
		}
	}

	/* loong start */
	.infos{
		position: absolute;
		top: 240px;
		left: 50%;
		margin-left: -250px;
		padding: 15px;
		width: 600px;
		border: 1px solid #ccc;
		border-radius: 15px;
		box-shadow: 2px 2px 2px #000;
		background-color: #fff;
	}

	.infos_row{
		padding: 0 20px;
	}

	.infos_row *{
		font-weight: 100;
		line-height: 33px;
	}
	.infos_row.infos_red *{
		color: red;
	}

	.infos_row label{
		display: inline-block;
		width: 175px;
		text-align: left;
	}

	.infos_row span.b{
		margin-right: 10px;
		font-weight: 500;
	}
	.infos_row p{
		margin-top: 30px;
		line-height: 20px;
		font-size: 14px;
		font-weight: 500;
		color: #808080;
	}

	.infos_row a.right{
		float: right;
		margin-right: 10px;
		padding: 0 10px;
		display: inline-block;
		height: 25px;
		line-height: 25px;
		color: #fff;
		font-size: 12px;
		text-decoration: none;
		border: 1px solid;
		border-color: #409eff;
		border-radius: 4px;
		background-color: #409eff;
	}
	.infos_row a.right:hover{
		background-color: #58abff;
	}
	.infos_row i.el-icon-warning{
		margin-left: 5px;
		cursor: pointer;
		color: #ccc;
	}
	.infos_row i.el-icon-warning:hover{
		color: #409eff;
	}
	.text_blue{color: blue; width: auto !important;}
	.text_bold{font-weight: bold; width: auto !important;}
	.text_red{color: red; width: auto !important;}
	/* loong end */
</style>
<script>
	import QRCode from 'qrcodejs2';
	import { mapMutations } from 'vuex'
	import '@/assets/qrcode.js'
	export default {
		name: 'order-create',
		data() {
			return {
				nextLock: false,
				typeKey: null,
				unitKey: '',
				next: '',
				firstStep: true,
				erImg:false,
				total: '',
				total_dun: '',
				paytype:'',
				payImg:'',
				printItem:false,
				mode:false,
				payMessage:'支付中......',
				items:[],
				orderinfo: {
					orderid: '',
					ordercode: '',
					metercode: '',
					pay_type: '',
					owner_name: '',
					owner_phone: '',
					address: '',
					balance_after: '',
					balance_before: '',
					total: '',
					overdraft: '',
					order_title: '',
				},
				formLabelWidth: '120px',

				// jt
				is_annual: 0,
				ladderShow: false,
				ladderinfo: {
					level: null,
					exceed: null,
					diff: null,
					first: null,
					two: null,
					firstDiff: null,
					twoDiff: null,
					yeartotal: null,
					money: null,
					pocket_money: null,
					amount: null,
				},
				nextType: null,

			} //return的结尾       window.location.href    8129
		},
		created:function(){
			this.postPayType()
		},
		methods: {
			postPayType(){
				this.typeKey = this.$route.params.type
				this.unitKey = this.$route.params.unit
				var code = this.$route.params.metercode
				this.$jssdk.order.getPaytype({metercode:code},(data) =>{
					this.items = data
				})
			},
			closeErImg(){
				this.$router.push({name:'MeterList'})
			},

			// 下一步
			onNext(){
				if(this.nextLock == true) return;
				if(this.total.length === 0 && this.typeKey != '7')
					return this.$message('请输入金额');
				if(this.total_dun.length === 0 && this.typeKey == '7')
					return this.$message('请输入吨数');
				if(!this.paytype)
					return this.$message('请选择支付方式');
				this.nextLock = true;
				this.ladderTips();

				// this.$jssdk.ystair.isAnnual({
				// 	code: this.$route.params.metercode
				// }, (data) => {
				// 	this.is_annual = data.is_annual;
				// 	if(data.is_annual == 1){
				// 		this.createOrder()
				// 	} else {
				// 		this.ladderTips();
				// 	}
				// }, (error) => {
				// 	this.$message(error.msg);
				// })
			},

			// 阶梯
			ladderTips(){
				// if(this.is_annual == 3){
				// 	this.ladderShow = true;
				// }
				// this.firstStep = false;
				var that = this;
				this.$jssdk.ystair.payTip({
					pay_type: this.paytype,
					code: this.$route.params.metercode,
					money: (this.typeKey == 7 ? (this.total_dun * (this.unitKey == -1 ? '' : this.unitKey)) : this.total * 100)
				}, (data) => {
					setTimeout(() => {
						that.nextLock = false;
					}, 1000);
					if(data.is_annual == 1){
						this.createOrder();
						return ;
					} else if(data.is_annual == 3){
						this.ladderShow = true;
						localStorage['ladder'] = JSON.stringify(data);
					}
					this.firstStep = false
					this.ladderinfo = data;
					
					if(data.is_annual == 2){
						this.onLadder();
					}
				}, (error) => {
					setTimeout(() => {
						that.nextLock = false;
					}, 1000);
					this.$message(error.msg);
				})
			},

			// 阶梯详细订单
			onLadder(){
				this.$jssdk.ystair.yearCreate({
					metercode: this.$route.params.metercode,
					total: (this.typeKey == 7 ? (this.total_dun * (this.unitKey == -1 ? '' : this.unitKey)) : this.total * 100),
					pay_type: this.paytype,
					unit_price: (this.typeKey == 7 ? (this.unitKey == -1 ? '' : this.unitKey) : ''),
					meter_monry: Number(this.ladderinfo.amount) * 100,
					diff_money: Number(this.ladderinfo.diff) * 100,
					pocket_in: Number(this.ladderinfo.pocket_money) * 100,
					yeartotal: Number(this.ladderinfo.yeartotal) * 100,
				}, (data) => {
					this.nextType = 1;
					this.orderinfo = data
					this.next = true;
					this.ladderShow = false;
				}, (error) => {
					this.$message(error.msg);
				})
			},

			// 创建订单
			createOrder() {				
				this.$jssdk.order.create({
					metercode: this.$route.params.metercode,
					total: (this.typeKey == 7 ? (this.total_dun * (this.unitKey == -1 ? '' : this.unitKey)) : this.total * 100),
					pay_type: this.paytype,
					unit_price: (this.typeKey == 7 ? (this.unitKey == -1 ? '' : this.unitKey) : ''),
				}, (data) => {
					this.nextType = 0;
					this.orderinfo = data
					this.next = true;
					this.firstStep = false;
				}, (error) => {
					this.$message(error.msg);
				})

				return;

			},
			
			cancel() {
				if(this.nextType == 1){
					this.ladderShow = true;
				} else {
					this.firstStep = true;
				}
				this.next = false;
			},
			successOrder() {
				this.$jssdk.order.successOrder({
					orderid: this.orderinfo.orderid
				}, (data) => {
					this.erImg =true
					if(data.mode == 1){
						this.mode = true
						// var imgurlSp = data.pay_url.split('?url=')[1];
						var imgurlSp = data.pay_url;
						setTimeout(() => {
							var qrcode = new QRCode('qrcodes', {
								width: 200,
								height: 200,
								text: imgurlSp,
								colorDark: '#000',
								colorLight: '#fff'
							});
						}, 1000);
						this.payImg = data.pay_url
							const payStatus = setInterval(() =>{
							this.$jssdk.order.getStatus({orderid:this.orderinfo.orderid},(data) =>{
								if(data.status === 0){
									this.payMessage = "支付中....."
								}
								if(data.status === 1){
									this.payMessage = '支付成功'
									this.printItem = true
									clearInterval(payStatus)
								}
							})
						},10000)
					}
					if(data.mode == 2){
						// window.location.href = data.pay_url
						let routerData = this.$router.resolve({path: '/payGateWay', query: {htmlData: data.pay_url}});
						// window.open(routerData.href, '_blank');
						document.location.href = routerData.href
					}
					if(data.mode == 3){
						const payStatus = setInterval(() =>{
							this.$jssdk.order.getStatus({orderid:this.orderinfo.orderid},(data) =>{
								if(data.status === 0){
									this.payMessage = "支付中....."
								}
								if(data.status === 1){
									this.payMessage = '支付成功'
									this.printItem = true
									clearInterval(payStatus)
								}
							})
						},1000)
					}
				}, (error) => {
					this.$message.warning(error.msg)
				})
			},
			successOrderAndPrint() {
				this.$jssdk.order.successOrder({
					orderid : this.orderinfo.orderid
				},(data) => {
					this.print(this.orderinfo.orderid)
					this.$router.back()
				}, (error) => {
					this.$message.warning(error.msg)
				})
			},
			/*print(orderId) {
				this.$jssdk.order.orderInfo({
					orderid: this.orderinfo.orderid
				}, (data) => {
					this.setPrintData(data)
					this.$nextTick(() => {
						window.print()
						this.$router.push({name:'MeterList'})
					})
				})
			},*/
			...mapMutations(['setPrintData']),

			// 分 => 元
			yuan(num){
				return num;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// OrderCreate.vue?4d2608d4